export const STORE_MARKER_PATH = 'icons/map_pin.svg';
